import { useEffect, useState } from "react";
import { tryApiGet } from "../api/client";
import type { BackboneResponse } from "../api/types";
import { historyQuery } from "../lib/auditHistory";

// The backbone snapshot payload (GET /api/audit/backbone?window=...), shared by
// the Distance and Signal tabs and the Hops view in Paths. Same query and
// pending handling as TopologyTab. null = loading.
export type BackbonePayloadState = BackboneResponse | null | "unavailable" | "pending";

export function useBackbonePayload(windowKey: string, takenAt?: string | null): BackbonePayloadState {
  const [data, setData] = useState<BackbonePayloadState>(null);
  useEffect(() => {
    let cancelled = false;
    setData(null);
    tryApiGet<BackboneResponse | { pending: true }>(`/api/audit/backbone?window=${windowKey}${historyQuery(takenAt)}`)
      .then((res) => {
        if (cancelled) return;
        if (res && "pending" in res && res.pending) setData("pending");
        else setData((res as BackboneResponse | null) ?? "unavailable");
      })
      .catch(() => !cancelled && setData("unavailable"));
    return () => {
      cancelled = true;
    };
  }, [windowKey, takenAt]);
  return data;
}
